import { Skeleton } from "@/components/ui/skeleton";

export const UpcomingCourseSkeleton = () => {
  return (
    <div className="container my-12 flex flex-col items-start justify-between gap-4 bg-blue-100 p-6 lg:my-36 lg:flex-row lg:items-center lg:gap-8 lg:p-10">
      {/* Heading skeleton */}
      <Skeleton className="mx-auto h-12 w-64 rounded-md lg:mx-0 lg:h-20 lg:w-96" />

      {/* Button skeleton */}
      <Skeleton className="mx-auto h-12 w-36 rounded-full lg:mx-0 lg:w-44" />
    </div>
  );
};
